import { defineStore } from 'pinia';
import { useDataStore } from './useDataStore';
import { simpleDebugLog } from '@/utils/simpleDebugLogger';

export interface UserStoreState {
  userId: string;
  initialized: boolean;
}

export const useUserStore = defineStore('user', {
  state: (): UserStoreState => ({
    userId: '09f2780b-6785-4b16-b94a-7605eb5cc1ba', // Default to Ryan Woo
    initialized: false, // Track if the store has been properly initialized
  }),
  getters: {
    // Get the current user's name from contacts data
    name: state => {
      const dataStore = useDataStore();
      if (!dataStore.contactsData?.contacts) {
        simpleDebugLog.warn('UserStore: No contacts data available');
        return null;
      }
      const user = dataStore.contactsData.contacts.find(c => c.id === state.userId);
      if (!user) {
        simpleDebugLog.warn(`UserStore: User not found with ID: ${state.userId}`);
        return null;
      }
      return user.name || null;
    },
    // Get the current user's title from contacts data
    title: state => {
      const dataStore = useDataStore();
      if (!dataStore.contactsData?.contacts) {
        return null;
      }
      const user = dataStore.contactsData.contacts.find(c => c.id === state.userId);
      return user?.title || null;
    },
    // Get the full user object from contacts data
    userData: state => {
      const dataStore = useDataStore();
      if (!dataStore.contactsData?.contacts) {
        return null;
      }
      return dataStore.contactsData.contacts.find(c => c.id === state.userId) || null;
    },
  },
  actions: {
    setUserId(id: string): void {
      this.userId = id;
      this.initialized = true;
    },
    // Initialize the user store with data
    initialize(): void {
      // Only initialize if not already initialized
      if (!this.initialized) {
        // Make sure the ID is valid by checking against the contacts
        const dataStore = useDataStore();
        const validUser = dataStore.contactsData?.contacts?.find(c => c.id === this.userId && c.is_system_user);

        // If the current ID is invalid, reset to Ryan Woo's ID
        if (!validUser) {
          this.userId = '09f2780b-6785-4b16-b94a-7605eb5cc1ba'; // Ryan Woo's ID
        }

        this.initialized = true;
      }
    },
  },
  persist: true,
});
